import config from 'config'
import {BRANDS, LOGIN_CASES, URLS_TO_REDIRECT} from 'const'
import {NOTIFICATION_TYPES} from 'const/notifications'
import {FOOTER_LOGO_TYPES} from 'const/logos'
import {getLandingPageRoute} from 'utils/redirections'
import {getDefaultConfig, getFooterLogosByBrandList} from '../../brands/commonHelper'

const NORMAL_FONT = '"Open Sans Regular", Helvetica, Arial, sans-serif'
const BOLD_FONT = '"Open Sans Bold", Helvetica, Arial, sans-serif'
const SEMIBOLD_FONT = '"Open Sans SemiBold", Helvetica, Arial, sans-serif'
const TITLE_FONT = '"Montserrat Bold", Helvetica, Arial, sans-serif'

export default {
  brand: {
    name: BRANDS.onelog,
    url: getLandingPageRoute(URLS_TO_REDIRECT.About),
    favicon: `${config.url}/assets/onelog-favicon.png`,
    fontColor: '#FFFFFF',
    support: getLandingPageRoute(URLS_TO_REDIRECT.Support),
  },
  config: {
    ...getDefaultConfig(),
    useCircularSocialLogin: true,
    onePager: ({loginCase}) => LOGIN_CASES.EMAIL_ONLY === loginCase,
  },
  fontConfig: {
    custom: {
      urls: [`${config.url}/fonts/onelog/index.css`],
    },
  },
  font: {
    family: NORMAL_FONT,
    fontWeight: 'normal',
    boldFamily: BOLD_FONT,
    boldFontWeight: 'bold',
    size: '16px',
    height: '24px',
    mobile: {
      size: '16px',
      height: '24px',
    },
    portrait: {
      size: '16px',
      height: '24px',
    },
    color: {
      dark: '#3C5162',
      light: '#FFFFFF',
    },
  },
  secondaryFont: {
    size: '14px',
    height: '21px',
    mobile: {
      size: '14px',
      height: '21px',
    },
    portrait: {
      size: '14px',
      height: '21px',
      backlink: '14px',
    },
  },
  title: {
    family: TITLE_FONT,
    size: '26px',
    height: '34px',
    mobile: {
      size: '26px',
      height: '34px',
    },
    portrait: {
      size: '34px',
      height: '46px',
    },
    weight: '700',
  },
  ringierBanner: {
    benefitsIcon: `${config.url}/assets/SI-icon-check-banner.svg`,
    linkColor: '#3C5162',
    linkHoverColor: '#2A3D4C',
    linkFontSize: '14px',
    padding: '20px',
    margin: '0 0 0 60px',
    benefitMessageColor: '#3C5162',
    backgroundColor: '#F6F6F6',
    fontSize: '16px',
    lineHeight: '24px',
    iconWidth: '24px',
    iconHeight: '24px',
    landscape: {
      fontSize: '16px',
      titleFontSize: '16px',
    },
    titleFontWeight: '700',
    titleFontFamily: BOLD_FONT,
    borderRadius: '8px',
    onelogTitle: {
      fontSize: '14px',
      fontWeight: '700',
      lineHeight: '21px',
      color: '#3C5162',
      fontFamily: BOLD_FONT,
      margin: '0 0 20px 0',
      portraitFontSize: '14px',
      portraitLineHeight: '21px',
    },
    onelogSection: {
      padding: '40px 0 0 0',
      borderTop: '1px solid #CDD5DB',
    },
    onelogLogo: {
      src: `${config.url}/assets/onelog-logo-navy.svg`,
    },
  },
  otherBrandsLogos: getFooterLogosByBrandList([BRANDS.blick, BRANDS.twentymin, BRANDS.tagesanzeiger, BRANDS.srg]),
  note: {
    family: BOLD_FONT,
    lightFamily: NORMAL_FONT,
    fontSize: '16px',
    fontWeight: '700',
    lightFontWeight: '400',
    lightColor: '#3C5162',
    termsTitle: {
      fontSize: '14px',
      fontWeight: '600',
      fontFamily: SEMIBOLD_FONT,
    },
    termsText: {
      fontSize: '14px',
      lineHeight: '21px',
    },
  },
  userDeletionMessage: {
    marginTop: '20px',
    paddingTop: '20px',
    fontSize: '14px',
    lineHeight: '21px',
    borderTop: '1px solid #cdd5db',
  },
  notification: {
    family: SEMIBOLD_FONT,
    success: '#38B25D',
    error: '#D73D40',
    pageError: '#D73D40',
    warning: '#FFAC5A',
    info: '#029DD2',
    icon: {
      width: '24px',
      height: '24px',
      mobile: {
        width: '32px',
        height: '32px',
      },
    },
    pageMessage: {
      size: '16px',
      height: '24px',
      sizeMobile: '16px',
      heightMobile: '24px',
      marginTop: '20px',
      borderRadius: '4px',
      colorFunc: type => {
        switch (type) {
          case NOTIFICATION_TYPES.warning:
            return '#000000'
          case NOTIFICATION_TYPES.success:
          case NOTIFICATION_TYPES.info:
          case NOTIFICATION_TYPES.error:
          default:
            return '#FFFFFF'
        }
      },
    },
  },
  buttons: {
    height: '48px',
    primary: {
      border: 0,
      color: '#FFFFFF',
      background: '#4DBAB4',
      hoverBorder: 0,
      hoverBackground: '#26ACA4',
      focusBorder: '2px solid #3C5162',
      focusBackground: '#4DBAB4',
      activeBackground: '#4DBAB4',
      isAnimated: true,
    },
    secondary: {
      border: '1px solid #4DBAB4',
      color: '#4DBAB4',
      background: '#FFFFFF',
      hoverBorder: '1px solid #26ACA4',
      hoverColor: '#26ACA4',
      hoverBackground: '#FFFFFF',
      focusBorder: '2px solid #3C5162',
      focusBackground: '#FFFFFF',
      activeBorder: '1px solid #26ACA4',
      activeColor: '#26ACA4',
      activeBackground: '#FFFFFF',
      dotsColor: '#4DBAB4',
    },
    profilePrimary: {
      border: 0,
      color: '#ffffff',
      background: '#3C5162',
      hoverBorder: 0,
      hoverBackground: '#2A3D4C',
      focusBorder: '2px solid #9BA5AD',
      isAnimated: true,
    },
    profileSecondary: {
      border: '1px solid #9BA5AD',
      color: '#3C5162',
      background: '#FFFFFF',
      hoverBorder: '1px solid #3C5162',
      focusBorder: '2px solid #3C5162',
      activeBorder: '2px solid #3C5162',
    },
    disabled: {
      border: 0,
      color: '#848484',
      background: '#D8D8D8',
      hoverBorder: 0,
      hoverBackground: '#D8D8D8',
      activeBorder: 0,
      activeBackground: '#D8D8D8',
    },
    swiss: {
      border: '1px solid #9BA5AD',
      color: '#3C5162',
      background: '#FFFFFF',
      hoverBorder: '1px solid #3C5162',
      hoverBackground: '#FFFFFF',
      focusBorder: '2px solid #3C5162',
      focusBackground: '#FFFFFF',
      activeBorder: '2px solid #3C5162',
      activeBackground: '#FFFFFF',
      icon: 'swiss_id_rot.png',
      iconStyles: {
        padding: '12px',
        marginLeft: '0',
      },
      textStyles: {
        weight: 700,
        family: BOLD_FONT,
      },
      hoverColor: '#2A3D4C',
      activeColor: '#2A3D4C',
      isAnimated: false,
      full: true,
    },
    facebook: {
      border: '1px solid #9BA5AD',
      color: '#3C5162',
      background: '#FFFFFF',
      hoverBorder: '1px solid #3C5162',
      hoverBackground: '#FFFFFF',
      focusBorder: '2px solid #3C5162',
      focusBackground: '#FFFFFF',
      activeBorder: '2px solid #3C5162',
      activeBackground: '#FFFFFF',
      icon: 'icon-facebook-24x24.svg',
      iconStyles: {
        padding: '12px',
        marginLeft: '0',
      },
      textStyles: {
        weight: 700,
        family: BOLD_FONT,
      },
      isAnimated: false,
      full: true,
      hoverColor: '#2A3D4C',
      activeColor: '#2A3D4C',
    },
    apple: {
      border: '1px solid #9BA5AD',
      color: '#3C5162',
      background: '#FFFFFF',
      hoverBorder: '1px solid #3C5162',
      hoverBackground: '#FFFFFF',
      focusBorder: '2px solid #3C5162',
      focusBackground: '#FFFFFF',
      activeBorder: '2px solid #3C5162',
      activeBackground: '#FFFFFF',
      icon: 'logo-apple-black.svg',
      iconStyles: {
        padding: '12px',
        marginLeft: '0',
      },
      textStyles: {
        weight: 700,
        family: BOLD_FONT,
      },
      isAnimated: false,
      full: true,
      hoverColor: '#2A3D4C',
      activeColor: '#2A3D4C',
    },
    google: {
      border: '1px solid #9BA5AD',
      color: '#3C5162',
      background: '#FFFFFF',
      hoverBorder: '1px solid #3C5162',
      hoverBackground: '#FFFFFF',
      focusBorder: '2px solid #3C5162',
      focusBackground: '#FFFFFF',
      activeBorder: '2px solid #3C5162',
      activeBackground: '#FFFFFF',
      icon: 'icon-google-24x24.svg',
      iconStyles: {
        padding: '12px',
        marginLeft: '0',
      },
      textStyles: {
        weight: 700,
        family: BOLD_FONT,
      },
      isAnimated: false,
      full: true,
      hoverColor: '#2A3D4C',
      activeColor: '#2A3D4C',
    },
    touchId: {
      border: '2px solid #4DBAB4',
      color: '#FFFFFF',
      background: '#4DBAB4',
      hoverBorder: '2px solid #26ACA4',
      hoverBackground: '#26ACA4',
      focusBorder: '2px solid #3C5162',
      focusBackground: '#4DBAB4',
      activeBackground: '#4DBAB4',
      isAnimated: true,
      full: true,
      icon: 'icon-touchid.svg',
      iconStyles: {padding: '8px', marginLeft: '0'},
      height: '48px',
    },
    faceId: {
      border: '2px solid #4DBAB4',
      color: '#FFFFFF',
      background: '#4DBAB4',
      hoverBorder: '2px solid #26ACA4',
      hoverBackground: '#26ACA4',
      focusBorder: '2px solid #3C5162',
      focusBackground: '#4DBAB4',
      activeBackground: '#4DBAB4',
      isAnimated: true,
      full: true,
      icon: 'icon-faceid.svg',
      iconStyles: {padding: '8px', marginLeft: '0'},
    },
    anyId: {
      border: '2px solid #4DBAB4',
      color: '#FFFFFF',
      background: '#4DBAB4',
      hoverBorder: '2px solid #26ACA4',
      hoverBackground: '#26ACA4',
      focusBorder: '2px solid #3C5162',
      focusBackground: '#4DBAB4',
      activeBackground: '#4DBAB4',
      isAnimated: true,
      full: true,
      icon: 'icon-touchid.svg',
      iconStyles: {padding: '8px', marginLeft: '0'},
    },
    icon: {
      height: '24px',
      width: '24px',
    },
    text: {
      family: BOLD_FONT,
      color: '#004056',
      size: '16px',
      weight: '700',
      marginTop: '2px',
    },
    border: {
      radius: '4px',
    },
    linkOnSecondLine: true,
    dotsColor: '#FFFFFF',
  },
  link: {
    default: '#3C5162',
    hoverColor: '#2A3D4C',
    secondary: '#3C5162',
    secondaryHover: '#2A3D4C',
    isAgreementsLinkSecondary: true,
    textDecorationHover: 'underline',
    align: 'left',
  },
  logisterSection: {
    registerMarginTop: '20px',
    registerWeight: 300,
    subheaderBorderTop: '1px solid #d9d9d9',
    subheaderPadding: '12px 20px',
    subheaderFamily: BOLD_FONT,
    subheaderFontSize: '16px',
    subheaderLineHeight: '24px',
    subheaderTitleColor: '#000000',
    subheaderTitleMargin: '0 0 4px 0',
    subheaderLinkColor: '#000000',
    subheaderLinkHoverColor: '#000000',
    subheaderBackgroundColor: '#F6F6F6',
    noteColor: '#000000',
    noteFontSize: {
      default: '16px',
      portrait: '16px',
    },
    title: {
      textChangeBreakpoint: 'mobile',
      fontSize: {
        smallMobile: '26px',
        mobile: '26px',
        portrait: '34px',
        landscape: '34px',
        desktop: '34px',
      },
      lineHeight: {
        smallMobile: '35px',
        mobile: '35px',
        portrait: '46px',
        landscape: '46px',
        desktop: '46px',
      },
    },
    loginHint: {
      label: {
        fontSize: '16px',
        lineHeight: '24px',
      },
    },
    subtitle: {
      display: {
        portrait: 'none',
      },
      color: '#3C5162',
      fontSize: {
        default: '16px',
        portrait: '16px',
      },
      lineHeight: '24px',
      margin: '-12px 0 0',
      link: {
        color: '#3C5162',
        hoverColor: '#3C5162',
      },
    },
  },
  form: {
    border: '',
    background: '#F7F7F7',
    fieldBackground: '',
    padding: '0 0 12px 0',
    sectionViewBackground: '#f8f8f8',
    marginBottom: '8px',
    loginSubmitMarginTop: '0',
  },
  logisterForm: {
    border: '',
    background: '',
    padding: '',
    submitButton: 'primary',
    forgetLinkFloat: 'right',
  },
  loginForm: {
    forgetLink: {
      wrapper: {
        defaultMarginBottom: '20px',
        errorMarginBottom: '22px',
      },
      link: {
        fontSize: '14px',
        marginTop: '6px',
      },
    },
  },
  registerPage: {
    backLinkMargin: {
      default: '0 0 12px',
      portrait: '0 0 12px',
    },
    titleMargin: {
      default: '0 0 20px',
      portrait: '0 0 20px',
    },
    titleSize: {
      default: '34px',
    },
    titleHeight: {
      default: '46px',
    },
    subtitle: {
      fontSize: '18px',
      lineHeight: '27px',
      fontFamily: TITLE_FONT,
      fontWeight: 700,
    },
    submitButtonMarginTop: 0,
  },
  emailVerifyPage: {
    subtitleMarginBottom: '20px',
    subtitleFontSize: '18px',
    linkMarginBottom: '10px',
    noteMarginBottom: '8px',
    linkingMessageMarginTop: '24px',
    note: {
      fontFamily: TITLE_FONT,
      fontSize: '18px',
    },
  },
  emailVerifiedPage: {
    subtitle: {
      fontFamily: TITLE_FONT,
      fontSize: '18px',
    },
  },
  field: {
    error: {
      background: 'inherit',
      fontColor: '#D73D40',
      size: '14px',
      height: '21px',
      padding: '4px 20px 0',
      margin: '0 -20px',
    },
    label: {
      color: '#3C5162',
      errorColor: '#D73D40',
      disabledColor: 'rgba(31,31,31,0.6)',
      family: SEMIBOLD_FONT,
      boldFamily: BOLD_FONT,
      fontSize: '14px',
      fontHeight: '21px',
      bottomMargin: '4px',
      fontWeight: '600',
    },
    edging: {
      backgroundColor: '#F7F7F7',
    },
    optional: {
      family: NORMAL_FONT,
      color: '#666666',
      fontSize: '14px',
      lineHeight: '21px',
    },
  },
  input: {
    background: '#FFFFFF',
    border: '1px solid #9BA5AD',
    focusBorder: '1px solid #3C5162',
    errorBorder: '1px solid #D73D40',
    hoverBorder: '1px solid #9BA5AD',
    borderRadius: '4px',
    height: '48px',
    fontSize: {
      mobile: '16px',
      portrait: '16px',
    },
    color: '#3C5162',
    padding: '12px',
    textView: {
      fontSize: '16px',
      lineHeight: '24px',
    },
    email: {
      color: '#3C5162',
      backgroundColor: '#F6F6F6',
      border: '0',
      borderRadius: '4px',
      button: {
        height: '32px',
        right: '12px',
        backgroundColor: '#FFFFFF',
        color: '#4DBAB4',
        fontFamily: SEMIBOLD_FONT,
        fontSize: '14px',
        textDecoration: 'none',
        border: '1px solid #4DBAB4',
        borderRight: '1px solid #4DBAB4',
        borderRadius: '4px',
        hoverColor: '#26ACA4',
        hoverBorder: '1px solid #26ACA4',
        hoverBorderRight: '1px solid #26ACA4',
      },
    },
    password: {
      color: '#3C5162',
      hoverColor: '#2A3D4C',
      size: '14px',
      height: '21px',
      top: '14px',
    },
    loading: {top: '7px'},
    placeholder: {
      color: '#CDD5DB',
    },
  },
  checkbox: {
    icon: {
      height: '20px',
      width: '20px',
      top: '0',
      right: '12px',
      image: 'OL-form-checkbox-default.svg',
      checkedImage: 'OL-form-checkbox-checked.svg',
      hoverImage: 'OL-form-checkbox-hover.svg',
      errorImage: 'OL-form-checkbox-error.svg',
      disabledImage: 'OL-form-checkbox-inactive.svg',
    },
    borderRadius: '8px',
    errorMargin: '',
    padding: '16px 20px',
    labelFontHeight: '22px',
    group: {
      label: {
        marginBottom: '8px',
        padding: '0',
        backgroundColor: '',
      },
      title: {
        padding: '24px 0 0 0',
      },
      marginBottom: '6px',
      padding: '0 24px',
      backgroundColor: '#F7F7F7',
      borderRadius: '0',
      family: BOLD_FONT,
      fontWeight: '400',
      fontSize: '16px',
      content: {
        padding: '24px 0 0 0',
      },
      item: {
        padding: '0 0 24px 0',
      },
      note: {
        fontWeight: '300',
        fontSize: '14px',
        profileMarginLeft: '32px',
        marginLeft: '28px',
        color: '#3C5162',
      },
    },
    groupedNewsletters: {
      heading: {
        title: {
          padding: '24px 0 0 0',
          fontSize: '16px',
          color: '#212427',
        },
      },
      separatorColor: '#CDD5DB',
      content: {
        heading: {
          padding: '24px 0',
          margin: '0 0 24px 0',
        },
      },
    },
    errorPadding: '4px 20px 0',
  },
  select: {
    icon: {
      width: '16px',
      height: '16px',
      image: 'onelog-form-arrow-down.svg',
      focusImage: 'onelog-form-arrow-down.svg',
      alt_image: 'onelog-form-arrow-down.svg',
    },
    menu: {
      border: '1px solid #D8D8D8',
      borderRadius: '0 0 8px 8px',
      isCheckIconVisible: false,
      checkIcon: 'NRJ-check-form-grey.svg',
      option: {
        padding: '8px 12px',
        color: '#3C5162',
        fontSize: '14px',
        focusBorder: '0',
        focusBackground: '#F7F7F7',
        focusColor: '#3C5162',
        selectedFontFamily: BOLD_FONT,
      },
      singleValue: {
        color: '#3C5162',
      },
      list: {
        backgroundColor: '#FFFFFF',
        boxShadow: 'none',
      },
    },
    dropdownIndicator: {
      padding: '0',
    },
  },
  radio: {
    icon: {
      width: '20px',
      height: '20px',
      image: 'OL-form-radio.svg',
      checkedImage: 'OL-form-radio-active.svg',
      hoverImage: 'OL-form-radio-hover.svg',
      errorImage: 'OL-form-radio-error.svg',
      disabledImage: 'SI-form-radio-empty-inactive.svg',
      top: '0px',
    },
    errorMargin: '0 -20px 0px',
    labelFontHeight: '21px',
    labelMarginBottom: '8px',
    fontSize: '14px',
  },
  errorPage: {
    font: {
      height: '18px',
      portrait: {
        height: '30px',
      },
    },
  },
  inputNote: {
    color: '#3C5162',
    size: '14px',
    height: '21px',
    marginTop: '4px',
  },
  separator: {
    background: '#CDD5DB',
    color: '#3C5162',
    height: '1px',
    fontSize: '11px',
    lineHeight: '16px',
    portraitMargin: '24px 0 28px 0',
    lineMarginTop: '6px',
  },
  textarea: {
    height: '116px',
  },
  tab: {
    fontSize: '16px',
    desktop: {focusBorder: 'solid 4px #3C5162', bottomMargin: '-4px', height: '80px'},
    mobile: {icon: {border: 'solid 2px #ACACAC', width: '14px', height: '14px', color: '#FFFFFF'}},
  },
  mobileNumber: {
    questionLabel: {
      family: BOLD_FONT,
    },
    label: {
      marginBottom: '12px',
    },
    subtitle: {
      marginTop: '12px',
      family: NORMAL_FONT,
      fontSize: '16px',
      lineHeight: '24px',
    },
    select: {
      padding: '12px 0px 12px 12px',
      borderRadius: '4px 0px 0px 4px',
    },
    selectIcon: {
      padding: '0px 12px',
    },
    code: {
      letterSpacing: '6.6px',
      underline: {
        left: 'calc(50% - 45px)',
        marginLeft: 0,
      },
      paddingLeft: {
        normal: 'calc(50% - 45px)',
        error: 'calc(50% - 45px)',
      },
    },
    link: {
      fontSize: '14px',
      lineHeight: '21px',
    },
  },
  shell: {
    header: {
      color: '#FFFFFF',
      backgroundColor: '#4DBAB4',
      height: {
        default: '80px',
        onScroll: '56px',
        withEmail: '102px',
      },
      logo: {
        height: {
          default: '48px',
          small: '28px',
          onScroll: '40px',
        },
        src: {
          default: 'OL-logo-claim-EN-white.svg',
          small: 'logo-onelog-white.svg',
          onScroll: 'brands/onelog/logos/on-scroll.svg',
          byLang: {
            fr: 'OL-logo-claim-FR-white.svg',
            it: 'OL-logo-claim-IT-white.svg',
            en: 'OL-logo-claim-EN-white.svg',
            de: 'onelog-claim-white.svg',
          },
        },
      },
      hidePoweredLogo: true,
      languageSwitcher: {
        color: '#FFFFFF',
        activeColor: '#3c5162',
        backgroundColor: '#FFFFFF',
        menu: {
          fontSize: '14px',
          lineHeight: '22px',
          color: '#3c5162',
          hoverBackgroundColor: '#cdd5db',
        },
      },
      menu: {
        default: {
          color: '#FFFFFF',
          fontSize: '20px',
        },
        active: {
          color: '#FFFFFF',
          backgroundColor: '#3c5162',
          hoverBackgroundColor: '#6E7F8C',
          selectedBackgroundColor: '#4dbab4',
          separatorColor: '#2C3B47',
        },
      },
    },
    footer: {
      tenants: {
        logoColor: FOOTER_LOGO_TYPES.dark,
        color: '#3C5162',
        hoverColor: '#2A3D4C',
        backgroundColor: '#ECF0F3',
        fontSize: '14px',
        lineHeight: '20px',
        separatorColor: '#cdd5db',
      },
      copyright: {
        color: '#cdd5db',
        hoverColor: '#FFF',
        backgroundColor: '#3c5162',
        fontSize: '14px',
        lineHeight: '20px',
        separatorColor: '#cdd5db',
      },
    },
  },
  consent: {
    subtitle: {
      fontSize: '18px',
      lineHeight: '27px',
      fontFamily: TITLE_FONT,
      marginBottom: '8px',
    },
    checkbox: {
      marginBottom: '20px',
      paddingBottom: '',
    },
  },
  phoneNumber: {
    labelInsideView: false,
    container: {
      backgroundColor: '#FFFFFF',
      padding: '0',
    },
    select: {
      borderRadius: '4px 0 0 4px',
      borderRight: '1px solid #D8D8D8',
      hoverBorderRight: '1px solid #212121',
      focusBorderRight: '2px solid #212121',
      errorBorderRight: '1px solid #DF0D29',
    },
    input: {
      borderTopLeftRadius: '0',
    },
  },
  address: {
    padding: '20px 20px 8px 20px',
    borderRadius: '8px',
    inputBackgroundColor: '#FFFFFF',
    formFieldMarginBottom: '0px',
    checkboxPadding: '',
    link: {
      fontSize: '14px',
      lineHeight: '21px',
    },
    control: {
      fontSize: '14px',
      openedBorderRadius: '8px 8px 0 0',
      borderRadius: '8px',
    },
  },
  edging: {
    borderRadius: '4px',
  },
  mfa: {
    textFontSize: '16px',
    subtitleFontSize: '16px',
    backgroundColor: '#f8f8f8',
    inputBackgroundColor: '#FFFFFF',
  },
  newsletters: {
    backgroundColor: '#F7F7F7',
    padding: '16px 20px',
    marginBottom: '20px',
    title: {
      fontSize: '14px',
      lineHeight: '21px',
      marginBottom: '4px',
    },
    description: {
      fontSize: '14px',
      lineHeight: '21px',
    },
  },
  webauthn: {
    dropdown: {
      fontSize: '16px',
      color: '#3C5162',
      hoverColor: '#2A3D4C',
    },
  },
  languageSwitcher: {
    fontRegular: NORMAL_FONT,
    fontSemiBold: SEMIBOLD_FONT,
    fontBold: BOLD_FONT,
    listRightPosition: '0',
    listItemActiveColor: '#3C5162',
    listItemDefaultColor: '#3C5162',
    listItemHoverColor: '#F7F7F7',
  },
  newLanguageSwitcher: {
    color: '#000000',
    fontSize: '14px',
    lineHeight: '22px',
    fontFamily: NORMAL_FONT,
    activeFontFamily: BOLD_FONT,
    backgroundColor: '#FFFFFF',
    hoverBackgroundColor: '#FEF2F2',
  },
  profile: {
    copy: {
      title: {
        fontSize: '18px',
        lineHeight: '26px',
      },
      body: {
        fontSize: '16px',
        lineHeight: '24px',
      },
      tiny: {
        fontSize: '14px',
        lineHeight: '22px',
      },
      small: {
        fontSize: '12px',
        lineHeight: '18px',
      },
    },
  },
}
